import { useAppContext } from '@/context/context';
import { isWorldShalichUser } from '@/constants';
import { LocationOnOutlined } from '@mui/icons-material';
import { Box, Tooltip } from '@mui/material';
import { Dialog, IconButton } from '@sm-dashboard/ui-components';
import { GoogleMap } from '@react-google-maps/api';
import { useState } from 'react';
import { DrawingMarker } from './DrawingMarker';

export type AddressPickerData = {
  location: google.maps.LatLng | undefined | null;
  address: string;
};

const AddressMapPicker = ({
  setLocationPicker,
  icon
}: {
  setLocationPicker: React.Dispatch<React.SetStateAction<AddressPickerData | undefined>>;
  icon?: string;
}) => {
  const { isGoogleMapsApiLoaded, userPermission } = useAppContext();
  const [openMapDialog, setOpenMapDialog] = useState(false);
  const [lastMarker, setLastMarker] = useState<google.maps.Marker | null>(null);
  const isWorldUser = isWorldShalichUser(userPermission);

  const containerStyle = {
    height: '100%',
    width: '100%',
    borderRadius: '8px'
  };

  const center = {
    lat: lastMarker?.getPosition()?.lat() || (isWorldUser ? 20 : 31.794431983241022),
    lng: lastMarker?.getPosition()?.lng() || (isWorldUser ? 0 : 35.18878195954886)
  } as any;

  const handlePickerComplete = () => {
    if (lastMarker) {
      setLocationPicker({ location: lastMarker?.getPosition(), address: lastMarker?.getTitle() || '' });
      setOpenMapDialog(false);
    }
  };

  return (
    <>
      <Tooltip title="בחירת כתובת במפה">
        <IconButton
          shape="circle"
          color="info"
          size="large"
          aria-label="בחירת כתובת במפה"
          onClick={() => setOpenMapDialog(true)}
        >
          <LocationOnOutlined />
        </IconButton>
      </Tooltip>
      <Dialog
        onClose={() => setOpenMapDialog(false)}
        aria-labelledby="customized-dialog-title"
        open={openMapDialog}
        fullWidth={true}
        maxWidth="md"
        title="בחירת כתובת במפה"
        primaryAction={{ label: 'בחר מיקום', onClick: handlePickerComplete, disabled: !lastMarker }}
      >
        {isGoogleMapsApiLoaded && (
          <Box sx={{ height: '50vh' }}>
            <GoogleMap
              options={{
                fullscreenControlOptions: { position: google.maps.ControlPosition.RIGHT_BOTTOM },
                mapTypeControlOptions: { position: google.maps.ControlPosition.BOTTOM_LEFT }
              }}
              center={center}
              zoom={isWorldUser ? 2 : 10}
              mapContainerStyle={containerStyle}
            >
              <DrawingMarker lastMarker={lastMarker} setLastMarker={setLastMarker} icon={icon} />
            </GoogleMap>
          </Box>
        )}
      </Dialog>
    </>
  );
};

export default AddressMapPicker;
